var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { icons } from './Icon.collection.js';
// Styles
import style from './Icon.css.js';
// Types
export const iconSizeOptions = [undefined, 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'];
/**
 * @element zz-icon
 */
export class Icon extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 'm';
        this.disabled = false;
    }
    static get styles() {
        return [style];
    }
    render() {
        return html `${unsafeHTML(icons[this.type])}`;
    }
}
__decorate([
    property({ type: String })
], Icon.prototype, "type", void 0);
__decorate([
    property({ type: String, reflect: true })
], Icon.prototype, "size", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], Icon.prototype, "disabled", void 0);
